import { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import BenefitsLandingPage from 'modules/benefits/pages/BenefitsLanding'
import UniversalImporterHealthcareBeneficiariesPage from 'modules/benefits/pages/UniversalImporterHealthcareBeneficiariesPage'

const RootPage = lazy(() => import('modules/benefits/pages/RootPage'))

const BenefitsGuardPage = lazy(() => import('modules/benefits/pages/BenefitsActiveGuardPage'))
const BenefitsHomePage = lazy(() => import('modules/benefits/pages/BenefitsHomePage'))
const AccountsPage = lazy(() => import('modules/benefits/pages/AccountsPage'))
const UsagePage = lazy(() => import('modules/benefits/pages/UsagePage'))
const EmployeesPage = lazy(() => import('modules/benefits/pages/EmployeesPage'))
const HealthcareManagementPage = lazy(
  () => import('modules/benefits/pages/HealthcareManagementPage')
)
export const benefitsRoutes: NavigationRoutesFn = (navigation) => [
  {
    path: navigation.benefits.path,
    handle: {
      module: 'benefits',
      moduleName: () => i18n.t('benefits.module_name'),
      meta: () => ({
        title: i18n.t('benefits.module_name'),
        description: i18n.t('payroll_bundle.payroll_issues.description'),
      }),
    },
    element: <RootPage />,
    children: [
      {
        element: <BenefitsGuardPage />,
        handle: {
          meta: () => ({
            title: i18n.t('benefits.module_name'),
            description: i18n.t('payroll_bundle.payroll_issues.description'),
            subNavigation: [
              {
                title: i18n.t('benefits.tabs.accounts.title'),
                href: navigation.benefits.fullPath(),
                index: true,
              },
              {
                title: i18n.t('benefits.tabs.employees.page.title'),
                href: navigation.benefits.employees.fullPath(),
              },
              {
                title: i18n.t('benefits.tabs.usage.title'),
                href: navigation.benefits.usage.fullPath(),
              },
              {
                title: i18n.t('benefits.tabs.catalog.title'),
                href: navigation.benefits.catalog.fullPath(),
              },
            ],
          }),
        },

        children: [
          {
            index: true,
            element: <AccountsPage />,
          },
          {
            path: navigation.benefits.accounts.path,
            element: <AccountsPage />,
          },
          {
            path: navigation.benefits.employees.path,
            element: <EmployeesPage />,
          },
          {
            path: navigation.benefits.usage.path,
            element: <UsagePage />,
          },
          {
            path: navigation.benefits.catalog.path,
            element: <BenefitsHomePage />,
          },
        ],
      },
      {
        path: `${navigation.benefits.catalog.path}/${navigation.benefits.catalog.healthcare.path}`,
        element: <HealthcareManagementPage />,
        handle: {
          resource: true,
          meta: () => ({
            title: i18n.t('benefits.healthcare.management.title'),
            ancestors: [
              {
                id: 1,
                title: i18n.t('benefits.tabs.catalog.title'),
                to: navigation.benefits.catalog.fullPath(),
              },
            ],
          }),
        },
        children: [
          {
            path: navigation.benefits.catalog.healthcare.importer.path,
            element: (
              <Routes>
                <Route
                  path=""
                  element={
                    <UniversalImporterHealthcareBeneficiariesPage
                      closePath={navigation.benefits.catalog.healthcare.fullPath()}
                    />
                  }
                />
              </Routes>
            ),
          },
        ],
      },
      {
        path: navigation.benefits.landing.path,
        element: <BenefitsLandingPage />,
      },
    ],
  },
]
